<mc-article-form
  [initialValues]="initialValues"
  [isSubmitting]="isSubmitting$ | async"
  [errors]="backendErrors$ | async"
  (articleSubmit)="onSubmit($event)"
></mc-article-form>
